module.exports = __webpack_public_path__ + "img/btn-cover-active.fe4a8b8a.svg";